import React from "react"
import styles from "./social.module.scss"
// import Helmet from "react-helmet"
// import { Link, withPrefix } from "gatsby"

const Social = (props) => {
  // console.log('Social props: '+ JSON.stringify(props))

  // Creates a pop-up to share the article
  function PopupCenter(url, title, w, h) {
    var left = (window.screen.width/2)-(w/2);
    var top = (window.screen.height/2)-(h/2)-(350/1.5);
    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
  }

  return(
    <div className={styles.container}>
      <button aria-label="facebook"
              className={styles.facebookButton}
              onClick={() => PopupCenter('https://www.facebook.com/sharer/sharer.php?u=https://www.journaldemontreal.com/deluge','Partager','650','350')}
      />
      <button aria-label="twitter"
              className={styles.twitterButton}

              onClick={() => PopupCenter('https://twitter.com/intent/tweet?url=https://www.journaldemontreal.com/deluge&amp;text=Partager','Partager','650','350')}
      />
      <a href="mailto:?subject=Vous devez lire cet article!&amp;body=Un article pour vous : https://www.journaldemontreal.com/deluge">
      <button aria-label="link" className={styles.linkButton}/>
      </a>
    </div>
  )
}

export default Social

